module.exports = __webpack_public_path__ + "static/media/img3.e8509ef4.jpeg";